


































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ssmPermissionService } from "@/shared/services/PermissionService";
import LayoutMenuModule from "@/store/modules/layout-menu-module";
import { MenuItem } from "../Menu/menu-item";
import { UtilsString } from "@/utils/utils-string";
import { RouterNames } from "@/router/routernames";
import menu_optionModule from "@/store/modules/menu_option-module";

@Component({
  components: {
    ModernMenuOption: () => import("./option/menu-option.vue"),
    ModernMenuGroup: () => import("./group/menu-group.vue"),
  },
})
export default class MenuRoot extends Vue {
  @Prop({ default: [] }) public fullMenuOptions!: MenuItem[];
  public appVersion = process.env.VUE_APP_VERSION;
  public appTitle = process.env.VUE_APP_TITLE || "Dashboard";
  public appSubtitle = process.env.VUE_APP_SUBTITLE || "Panel de Control";

  private menu: MenuItem[] = [];

  public get drawer(): boolean {
    return LayoutMenuModule.visible;
  }

  public get menuStyle() {
    return {
      height: `${this.menuHeight}px`,
      overflowX: "hidden",
      overflowY: "auto",
      paddingBottom: "20px",
    };
  }

  public get menuHeight() {
    return this.$vuetify.breakpoint.height - 250;
  }

  public set drawer(newToggle: boolean) {
    LayoutMenuModule.setVisible(newToggle);
  }

  public created() {
    this.createUserMenu();
  }

  public goToHome() {
    this.$router.push({ name: RouterNames.Home });
  }

  private refresh_menu() {
    menu_optionModule.getmenu();
  }

  private createUserMenu() {
    this.menu = [];
    for (const item of this.fullMenuOptions) {
      this.createUserMenuOpcion(item);
    }
  }

  private createUserMenuOpcion(item: MenuItem, parent?: MenuItem) {
    if (this.hasPermiso(item.permission)) {
      const newItem: MenuItem = this.newMenuItem(item);

      if (this.hasSubmenuOptions(item)) {
        for (const child of item.children) {
          this.createUserMenuOpcion(child, newItem);
        }
      }

      this.AddUserMenuOpcion(newItem, parent);
    }
  }

  private AddUserMenuOpcion(newItem: MenuItem, parent?: MenuItem) {
    if (
      !UtilsString.IsNullOrWhiteSpace(newItem.link) ||
      this.hasSubmenuOptions(newItem)
    ) {
      if (parent != null && parent.children != null) {
        parent.children.push(newItem);
      } else {
        this.menu.push(newItem);
      }
    }
  }

  private hasPermiso(permiso: string) {
    const result =
      UtilsString.IsNullOrWhiteSpace(permiso) ||
      ssmPermissionService.hasPermission(permiso);
    return result;
  }

  private hasSubmenuOptions(item: MenuItem): boolean {
    return item.children != null && item.children.length > 0;
  }

  private newMenuItem(item: MenuItem): MenuItem {
    const newItem = new MenuItem();
    newItem.icon = item.icon;
    newItem.text = item.text;
    newItem.link = item.link;
    newItem.color = item.color;
    newItem.icon_fntaws = item.icon_fntaws;
    newItem.permission = item.permission;
    newItem.children = [];
    return newItem;
  }
}
